"use client";

import { motion } from "framer-motion";

export interface ProjectGalleryBlockStyle {
    paddingTop?: string;
    paddingBottom?: string;
    backgroundColor?: string;
    gap?: string;
}

export interface ProjectGalleryBlockProps {
    mainImage: string;
    smallImages?: string[];
    style?: ProjectGalleryBlockStyle;
}

export default function ProjectGalleryBlock({
    mainImage,
    smallImages = [],
    style
}: ProjectGalleryBlockProps) {
    if (!mainImage && (!smallImages || smallImages.length === 0)) return null;

    return (
        <div
            className="w-full"
            style={{
                backgroundColor: style?.backgroundColor || "#FFFFFF",
                paddingTop: style?.paddingTop || "4rem",
                paddingBottom: style?.paddingBottom || "4rem",
            }}
        >
            <div className="container mx-auto px-4 md:px-12 lg:px-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-stretch">
                    {/* Main Image (Left, 8 cols) */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.8 }}
                        className="lg:col-span-8"
                    >
                        {mainImage && (
                            <img
                                src={mainImage}
                                alt="Gallery Main"
                                className="w-full h-full object-cover rounded-2xl"
                                style={{ minHeight: '400px' }}
                            />
                        )}
                    </motion.div>

                    {/* Small Images (Right, 4 cols) */}
                    <div className="lg:col-span-4 flex flex-col gap-6">
                        {smallImages.map((img, idx) => (
                            <motion.div
                                key={idx}
                                initial={{ opacity: 0, x: 20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6, delay: 0.2 + (idx * 0.1) }}
                                className="flex-1 overflow-hidden rounded-2xl"
                            >
                                <img
                                    src={img}
                                    alt={`Gallery Detail ${idx + 1}`}
                                    className="w-full h-full object-cover"
                                />
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
